import { useMemo } from 'react';
import { createSearchParams, URLSearchParamsInit, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { cleanObject } from '../utils/clean-object';

export function useRouter() {
	const location = useLocation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	// const match = useMatch();
	// Return our custom router object
	// Memoize so that a new object is only returned if something changes
	return useMemo(() => {
		const params = Object.fromEntries(new URLSearchParams(searchParams));

		// for(let [key, value] of searchParams.entries()) {
		// 	params[key] = value;
		// }

		return {
			// For convenience add push(), replace(), pathname at top level
			push: (path: string, query?: URLSearchParamsInit) => {
				navigate({
					pathname: path,
					search: `?${createSearchParams(cleanObject(query))}`,
				});
			},
			replace: (path: string, query?: URLSearchParamsInit) => {
				navigate(
					{
						pathname: path,
						search: `?${createSearchParams(cleanObject(query))}`,
					},
					{
						replace: true,
					}
				);
			},
			pathname: location.pathname,
			location,
			navigate,
			params,
		};
	}, [location, navigate, searchParams]);
}
